export default __webpack_public_path__ + "static/media/cost.d42e7193.svg";